import React, { useState } from "react";
import { generateWordProblem } from "./generators/generateWordProblem";
import { generateMoneyMath } from "./generators/generateMoneyMath";
import { generateTimeProblem } from "./generators/generateTimeProblem";

const CATEGORIES = [
  { key: "word", label: "Word Problems" },
  { key: "money", label: "Money Math" },
  { key: "time", label: "Time Problems" },
];

const QUESTION_GENERATORS = {
  word: generateWordProblem,
  money: generateMoneyMath,
  time: generateTimeProblem,
};

const SHEET_SIZES = [10, 25, 50];

export default function MathWordLifePractice() {
  const [category, setCategory] = useState("word");
  const [practice, setPractice] = useState(true);
  const [question, setQuestion] = useState(generateWordProblem());
  const [userAnswer, setUserAnswer] = useState("");
  const [feedback, setFeedback] = useState("");
  const [score, setScore] = useState(0);

  // Worksheet print mode
  const [sheet, setSheet] = useState([]);
  const [showAnswers, setShowAnswers] = useState(false);

  function nextQuestion() {
    setUserAnswer("");
    setFeedback("");
    setQuestion(QUESTION_GENERATORS[category]());
  }

  function checkAnswer() {
    if (parseFloat(userAnswer) === parseFloat(question.answer)) {
      setFeedback("✅ Correct!");
      setScore((s) => s + 1);
    } else {
      setFeedback(`❌ Incorrect. The answer is ${question.answer}`);
    }
    setTimeout(nextQuestion, 1200);
  }

  // Generate a new printable worksheet
  function makeSheet(n) {
    setSheet(Array.from({ length: n }, () => QUESTION_GENERATORS[category]()));
    setShowAnswers(false);
    setPractice(false);
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 80);
  }

  function backToPractice() {
    setSheet([]);
    setPractice(true);
    setFeedback("");
    setUserAnswer("");
    setQuestion(QUESTION_GENERATORS[category]());
  }

  // Print: browser native print is fine
  function printSheet() {
    window.print();
  }

  return (
    <div className="practice-container worksheet">
      <h2>World Life Practice</h2>
      <div className="control-row no-print">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.key}
            className={category === cat.key ? "selected" : ""}
            onClick={() => {
              setCategory(cat.key);
              setSheet([]);
              setPractice(true);
              setScore(0);
              setFeedback("");
              setUserAnswer("");
              setQuestion(QUESTION_GENERATORS[cat.key]());
            }}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* Sheet Mode */}
      {!practice && sheet.length > 0 && (
        <>
          <div className="worksheets-title">
            {CATEGORIES.find((c) => c.key === category).label} Worksheet
          </div>
          <div className="worksheet-buttons no-print">
            {SHEET_SIZES.map((n) => (
              <button key={n} onClick={() => makeSheet(n)}>
                {n} Qs
              </button>
            ))}
            <button onClick={printSheet}>Print</button>
            <button onClick={() => setShowAnswers((v) => !v)}>
              {showAnswers ? "Hide Answers" : "Show Answers"}
            </button>
            <button onClick={backToPractice}>Back to Practice</button>
          </div>
          <div className="sheet-grid">
            {sheet.map((q, i) => (
              <div key={i}>
                <span style={{ fontWeight: 600 }}>{i + 1}. </span>
                {q.text}
                <div className="math-underline" />
                {showAnswers && (
                  <div style={{ fontSize: "0.93em", color: "#2c8c3f", fontWeight: 600 }}>
                    Ans: {q.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {/* Interactive Practice Mode */}
      {practice && (
        <>
          <div className="worksheet-buttons no-print">
            <span style={{ marginRight: 7 }}>Worksheet:</span>
            {SHEET_SIZES.map((n) => (
              <button key={n} onClick={() => makeSheet(n)}>
                {n} Qs
              </button>
            ))}
          </div>
          <div className="current-question">
            <strong>Q:</strong> {question.text}
          </div>
          <form
            className="answer-form"
            onSubmit={(e) => {
              e.preventDefault();
              checkAnswer();
            }}
          >
            <input
              type="text"
              value={userAnswer}
              onChange={(e) => setUserAnswer(e.target.value)}
              placeholder="Your answer"
              autoFocus
            />
            <button type="submit">Submit</button>
          </form>
          <div style={{ minHeight: 28, marginBottom: 10 }}>{feedback}</div>
          <div className="score-text">Score: {score}</div>
        </>
      )}
    </div>
  );
}
